import { atom, useAtomValue, useSetAtom } from 'jotai';

const totalResultCountAtom = atom(0);

export const useSetAnalyzeResultTotalCountAtom = () => {
  return useSetAtom(totalResultCountAtom);
};

export const useAnalyzeTotalResultCountAtomValue = () => {
  return useAtomValue(totalResultCountAtom);
};
